<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Rooms'"
      [canGoBack]="true"
      [customBack]="'properties?propertyId=' + address?.id" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (!loaded && errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [header]="addressName"
          [translate]="false" />
      </tidy-row>
      @if (floors?.length == 0) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'No Rooms Added'" />
        </tidy-row>
        <tidy-button
          [text]="'Add Room'"
          [action]="goToAddRoomPage.bind(this, 1)"
          class="primary" />
      }
      @for (floor of floors; track floor; let i = $index) {
        @if (floor) {
          <tidy-row [alignLastItemRight]="true">
            <tidy-text
              [header]="'Floor'" /><span>&nbsp;</span>
              <tidy-text
                [header]="i" />
              <tidy-text
                [body]="'Add Room'"
                class="link"
                (action)="goToAddRoomPage(i)" />
            </tidy-row>
            @for (room of floor; track room) {
              <tidy-card class="no-padding">
                <tidy-card-button
                  class="arrow-to-top no-padding"
                  [customArrowPositon]="{ top: '18px', right: '15px' }"
                  (action)="goToEditRoomDetails(room)">
                  <tidy-row class="vertical-align-center extra-bottom-padding extra-top-padding extra-left-padding extra-right-padding">
                    <tidy-image
                      [src]="'assets/img/icons/rooms/' + room?.icon + '.svg'"
                      class="title-size" />
                    <tidy-text
                      [header]="room?.name"
                      [translate]="false" />
                  </tidy-row>
                </tidy-card-button>
              </tidy-card>
            }
          }
        }
        @if (cameFromBuildMap) {
          <tidy-button
            [text]="'Confirm Rooms'"
            [action]="boundConfirmRooms"
            class="primary" />
        }
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
